import { render } from "./ClientOnly.vue?vue&type=template&id=e9ed1b1c"
import script from "./ClientOnly.vue?vue&type=script&lang=js"
export * from "./ClientOnly.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__